import Box from "@mui/material/Box"
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

import Row from "../../../common/components/Row"

export default function PercentageCircularProgress({
  progress,
  fontSize = "1.25rem",
  size,
}) {
  const roundedProfileProgress = Math.round(progress)
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        size={size}
        value={100}
        sx={{ color: (theme) => theme.palette.colors.gray200 }}
      />
      <StyledCircularProgress
        variant="determinate"
        color="primary"
        size={size}
        value={Math.max(roundedProfileProgress, 1)}
      />
      <ProgressTextWrapper>
        <Typography variant="h6" fontSize={fontSize}>
          {roundedProfileProgress}%
        </Typography>
      </ProgressTextWrapper>
    </Box>
  )
}

const StyledCircularProgress = styled(CircularProgress)(() => ({
  position: "absolute",
  left: 0,
  [`& .${circularProgressClasses.circle}`]: {
    strokeLinecap: "round",
  },
}))

const ProgressTextWrapper = styled(Row)(() => ({
  position: "absolute",
  left: 0,
  top: 0,
  bottom: 0,
  right: 0,
  justifyContent: "center",
  alignItems: "center",
}))
